import { createTextComponent } from './createTextComponent';

export const H4 = createTextComponent({
  styleAs: 'h4',
  tag: 'h4',
});
